import { Spinner } from '@fluentui/react-components';
import React from 'react';

import Page from '../../component/shared/Page';
import IDQAPageContext from '../../context/business/IDQAPage/IDQAPageContext';
import ExplorerWrapper from './explorer/ExplorerWrapper';
import ProfilingDetailsView from './ProfilingDetailsView';

const IDQADetailsPage = () => (
	<Page>
		<IDQAPageContext>
			<React.Suspense fallback={<Spinner style={{ height: '100%' }} />}>
				<ExplorerWrapper>
					<ProfilingDetailsView />
				</ExplorerWrapper>
			</React.Suspense>
		</IDQAPageContext>
	</Page>
);

export default IDQADetailsPage;
